import {nonGroupedValues} from "@common/FilterComponent";
import {
  AttestationStatus,
  attestationStatusDisplayValues,
  CareJourneyEventType,
  CareJourneyPriority,
  DaysOpenValue,
  taskTypeDisplayValues
} from "@/api/dto/care-journey";

export const PriorityOptions: nonGroupedValues[] = [
  {label: 'Urgent', value: CareJourneyPriority.URGENT, id: CareJourneyPriority.URGENT},
  {label: 'None', value: 'NONE', id: 'NONE'},
];

export const StatusOptions: nonGroupedValues[] = [
  {label: 'In progress', value: 'active', id: 'active'},
  {label: 'Completed', value: 'completed', id: 'completed'},
  {label: 'Closed', value: 'closed', id: 'closed'},
];

export const ReferralReviewStatusOptions: nonGroupedValues[] = [
  {label: 'Pending Review', value: 'PENDING_REVIEW', id: 'Pending Review'},
  {label: 'Confirmed', value: 'CONFIRMED', id: 'Confirmed'},
  {label: 'Rejected', value: 'REJECTED', id: 'Rejected'},
];

export const EventTypeOptions: nonGroupedValues[] = [
  {label: 'ADT event', value: 'ADT', id: 'ADT'},
];

export const EventSettingOptions: nonGroupedValues[] = [
  {label: 'Inpatient', value: 'Inpatient', id: 'Inpatient'},
  {label: 'Emergency', value: 'Emergency', id: 'Emergency'},
  {label: 'Observation', value: 'Observation', id: 'Observation'},
  {label: 'Outpatient', value: 'Outpatient', id: 'Outpatient'},
  {label: 'Outpatient Surgery', value: 'Outpatient Surgery', id: 'Outpatient Surgery'},
  {label: 'Unknown', value: 'Unknown', id: 'Unknown'},
];


export const DaysOpenOptions: nonGroupedValues[] = [
  {label: '1 day', value: DaysOpenValue.OneDay, id: DaysOpenValue.OneDay},
  {label: '2-3 days', value: DaysOpenValue.TwoToThreeDays, id: DaysOpenValue.TwoToThreeDays},
  {label: '4-5 days', value: DaysOpenValue.FourToFiveDays, id: DaysOpenValue.FourToFiveDays},
  {label: '6-7 days', value: DaysOpenValue.SixToSevenDays, id: DaysOpenValue.SixToSevenDays},
  {label: 'More than 1 week', value: DaysOpenValue.MoreThanOneWeek, id: DaysOpenValue.MoreThanOneWeek},
  {label: 'More than 2 weeks', value: DaysOpenValue.MoreThanTwoWeeks, id: DaysOpenValue.MoreThanTwoWeeks},
  {label: 'More than 1 month', value: DaysOpenValue.MoreThanOneMonth, id: DaysOpenValue.MoreThanOneMonth},
  {label: 'More than 3 months', value: DaysOpenValue.MoreThanThreeMonths, id: DaysOpenValue.MoreThanThreeMonths},
  {label: 'More than 6 months', value: DaysOpenValue.MoreThanSixMonths, id: DaysOpenValue.MoreThanSixMonths},
  {label: 'More than 1 year', value: DaysOpenValue.MoreThanOneYear, id: DaysOpenValue.MoreThanOneYear},
];

// FLOWABLE_WORKFLOW is a temporary event type until workflows (and event types) are defined by product
// https://hbuco.atlassian.net/browse/CARECO-4605
export const TaskTypeOptions: nonGroupedValues[] = Object.values(CareJourneyEventType)
  .filter(eventType => eventType !== CareJourneyEventType.FLOWABLE_WORKFLOW)
  .map(eventType => ({ label: taskTypeDisplayValues[eventType], value: eventType, id: eventType }));

export const AttestationStatusOptions: nonGroupedValues[] = [
  {
    label: attestationStatusDisplayValues[AttestationStatus.NOT_READY],
    value: AttestationStatus.NOT_READY,
    id: AttestationStatus.NOT_READY
  },
  {
    label: attestationStatusDisplayValues[AttestationStatus.PENDING],
    value: AttestationStatus.PENDING,
    id: AttestationStatus.PENDING
  },
  {
    label: attestationStatusDisplayValues[AttestationStatus.COMPLETED],
    value: AttestationStatus.COMPLETED,
    id: AttestationStatus.COMPLETED
  },
  {
    label: attestationStatusDisplayValues[AttestationStatus.NOT_REQUIRED],
    value: AttestationStatus.NOT_REQUIRED,
    id: AttestationStatus.NOT_REQUIRED
  },
];

export const DaysSinceDischargeOptions: nonGroupedValues[] = [
  {label: '0 days', value: '0', id: '0'},
  ...Array.from({length: 30}, (_, i) => {
    const dayValue: number = i + 1;
    return {
      label: `${dayValue} ${dayValue === 1 ? 'day' : 'days'}`,
      value: dayValue.toString(),
      id: dayValue.toString(),
    };
  }),
];

export enum TasksSearchBy {
  NAME = 'name',
  TASK_ID = 'taskId',
}

export const searchByLabels: Record<TasksSearchBy, string> = {
  [TasksSearchBy.NAME]: 'Search by client name',
  [TasksSearchBy.TASK_ID]: 'Search by task ID',
};

export const searchByDropdownLabels: Record<TasksSearchBy, string> = {
  [TasksSearchBy.NAME]: 'Client name',
  [TasksSearchBy.TASK_ID]: 'Task ID',
};

